<template>
  <div class="notification" v-bind:class="classObject">
    <button class="delete" @click="closeNotification" aria-label="Close Notification"></button>
    <div v-for="(notification, idx) in notifications" :key="`notification-${idx}`">
      <span class="icon is-left">
        <font-awesome-icon :icon="['fal', 'check']"
        v-if="notificationType === 'success'" />
        <font-awesome-icon :icon="['fal', 'ban']"
        v-if="notificationType === 'danger'" />
        <font-awesome-icon :icon="['fal', 'exclamation-triangle']"
        v-if="notificationType === 'warning'" />
      </span>
      {{ notification.text }}
    </div>
  </div>
</template>

<script>
import NotificationManager from '@/mixins/NotificationManager';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faBan,
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';
library.add(
  faCheck,
  faBan,
  faExclamationTriangle,
);
export default {
  mixins: [NotificationManager],
  data() {
    return {
    };
  },
  computed: {
    classObject() {
      return {
        'is-success': this.notificationType === 'success',
        'is-danger': this.notificationType === 'danger',
        'is-warning': this.notificationType === 'warning',
      };
    },
  },
  methods: {
    closeNotification() {
      this.hideNotification();
    },
  },
};
</script>

<style lang="sass" scoped>

.notification
  top: 0
  position: sticky
  z-index: 10
  margin-bottom: 0

</style>
